import useNominationHistory from "./service";
import { NominationHistoryProps } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import { useStaticData } from "context/staticData";
import { useAuth } from "shared/context/auth";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export default function NominationHistory(props: NominationHistoryProps) {
  const copies = useCopies();
  const { userDetail } = useAuth();
  const service = useNominationHistory(props);
  const staticDataObj = useStaticData();

  if (!service.nominationHistory.length) {
    return null;
  }

  return (
    <div className="manageOrgAdmin_nominationHistory">
      <span className="manageOrgAdmin_nominationHistory_title">
        {copies.get("nomination.history.heading", {
          0:
            userDetail?.id === props.applicantId
              ? copies.get("participant.name.me", { 0: props.participantName })
              : props.participantName
        })}
      </span>
      <div className="manageOrgAdmin_nominationHistory_table">
        <table className="globalTable">
          <thead>
            <tr>
              <th>{copies.get("nominated.by")}</th>
              <th>{copies.get("status")}</th>
              <th>{copies.get("date")}</th>
            </tr>
          </thead>
          <tbody>
            {service.nominationHistory.map(history => {
              return (
                <tr key={history.id}>
                  <td>
                    {userDetail?.id === history.initiatorId
                      ? copies.get("participant.name.me", {
                          0: `${history.initiatorFirstName} ${history.initiatorLastName}`
                        })
                      : `${history.initiatorFirstName} ${history.initiatorLastName}`}
                  </td>
                  <td>{staticDataObj.nonAttendeeApplicationStatus[history.status]}</td>
                  <td>
                    {DateTimeHelper.formatDate({
                      startDate: history.initiationDate,
                      option: {
                        showTime: true
                      }
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
